import { render, staticRenderFns } from "./Observacion.vue?vue&type=template&id=200816b4&scoped=true"
import script from "./Observacion.vue?vue&type=script&lang=js"
export * from "./Observacion.vue?vue&type=script&lang=js"
import style0 from "./Observacion.vue?vue&type=style&index=0&id=200816b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200816b4",
  null
  
)

export default component.exports